/**
 * variant-selection-2.js
 * Handles click-to-switch for PDP quantity selection options from block settings.
 * Syncs with quantity selector: option selected sets quantity, quantity change activates matching option.
 */
(function () {
  function initVariantSelection2() {
    const containers = document.querySelectorAll('[data-variant-selection-2]');
    containers.forEach((container) => {
      const options = Array.from(container.querySelectorAll('[data-variant-selection-2-option]'));
      const quantityEl = container.querySelector('[data-variant-selection-2-quantity]');
      const fillEl = container.querySelector('[data-variant-selection-2-fill]');
      const markers = container.querySelectorAll('[data-variant-selection-2-marker]');
      const savingsSlots = container.querySelectorAll('[data-variant-selection-2-savings-slot]');
      const total = options.length;

      if (total === 0) return;

      const productContainer = container.closest('.product-container') || document;
      const quantityInput = productContainer.querySelector('main-atc input[name="quantity"], input[type="number"][name="quantity"]');

      const fillWidthPercent = 100 / total;

      function updateSavingsLabels(selectedIndex) {
        const selectedOption = options[selectedIndex];
        const savingsAmount = selectedOption?.dataset.savingsAmount || '';
        const discountPercent = parseInt(selectedOption?.dataset.discountPercent, 10) || 0;
        const hasDiscount = discountPercent > 0 && savingsAmount;
        savingsSlots.forEach((slot) => {
          slot.textContent = hasDiscount ? `Spare ${savingsAmount}` : '';
        });
      }

      function setSelected(index, updateQuantityInput) {
        const selectedOption = options[index];
        options.forEach((opt, i) => {
          opt.classList.toggle('variant-selection-2__option--selected', i === index);
        });
        markers.forEach((m, i) => {
          m.classList.toggle('variant-selection-2__marker--active', i === index);
        });

        const title = selectedOption?.dataset.variantTitle || '';
        if (quantityEl) quantityEl.textContent = title;

        if (fillEl) {
          fillEl.style.width = `${(index + 1) * fillWidthPercent}%`;
        }

        updateSavingsLabels(index);

        if (updateQuantityInput !== false && quantityInput && selectedOption?.dataset.optionQuantity) {
          const qty = parseInt(selectedOption.dataset.optionQuantity, 10) || 1;
          quantityInput.value = qty;
        }

        // Store discount code for cart drawer (e.g. 2-item vs 4-item discounts)
        const discountCode = selectedOption?.dataset.discountCode?.trim() || '';
        if (discountCode) {
          try { sessionStorage.setItem('pdpDiscountCode', discountCode); } catch (e) {}
        } else {
          try { sessionStorage.removeItem('pdpDiscountCode'); } catch (e) {}
        }
      }

      function clearSelection(qtyValue) {
        options.forEach((opt) => opt.classList.remove('variant-selection-2__option--selected'));
        markers.forEach((m) => m.classList.remove('variant-selection-2__marker--active'));
        if (quantityEl) quantityEl.textContent = qtyValue || '';
        if (fillEl) fillEl.style.width = '0%';
        savingsSlots.forEach((slot) => { slot.textContent = ''; });
        try { sessionStorage.removeItem('pdpDiscountCode'); } catch (e) {}
      }

      function selectMatchingOption(qtyValue) {
        const qty = parseInt(qtyValue, 10);
        if (isNaN(qty) || qty < 1) return;

        const sortedOptions = options
          .map((opt, i) => ({ opt, i, qty: parseInt(opt.dataset.optionQuantity, 10) || 1 }))
          .sort((a, b) => a.qty - b.qty);

        const firstThreshold = sortedOptions[0]?.qty || 1;
        if (qty < firstThreshold) {
          clearSelection(qtyValue);
          return;
        }

        let matchIndex = -1;
        for (let j = sortedOptions.length - 1; j >= 0; j--) {
          if (qty >= sortedOptions[j].qty) {
            matchIndex = sortedOptions[j].i;
            break;
          }
        }
        if (matchIndex >= 0) setSelected(matchIndex, false);
      }

      setSelected(0);

      options.forEach((option, index) => {
        option.addEventListener('click', () => setSelected(index));
        option.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setSelected(index);
          }
        });
      });

      if (quantityInput) {
        quantityInput.addEventListener('input', () => selectMatchingOption(quantityInput.value));
        quantityInput.addEventListener('change', () => selectMatchingOption(quantityInput.value));
        productContainer.addEventListener('quantity-changed', (e) => selectMatchingOption(e.detail.quantity));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantSelection2);
  } else {
    initVariantSelection2();
  }
})();
